// extracted by mini-css-extract-plugin
module.exports = {"valueList":"component_valueList__3MuIs","val":"component_val__2T3NI"};